import BrandLogo from './BrandLogo';
import { LogIn } from 'lucide-react';
import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { type Locale, useI18n } from '../i18n';

export default function PublicAppHeader({ actions }: { actions?: ReactNode }) {
  const { locale, setLocale, t } = useI18n();
  const loginLabel = locale === 'en' ? 'Log in' : 'Inloggen';

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-gray-200 bg-white px-3 sm:px-6">
      <BrandLogo />
      <div className="flex items-center gap-2">
        <select
          aria-label={t('language')}
          value={locale}
          onChange={event => setLocale(event.target.value as Locale)}
          className="h-9 rounded-md border-gray-300 bg-white px-2 text-sm font-semibold text-gray-700 shadow-sm focus:border-orange-500 focus:ring-orange-500"
        >
          <option value="nl">🇳🇱 NL</option>
          <option value="en">🇬🇧 EN</option>
        </select>
        {actions === undefined ? <Link
          to={`/${locale}/login`}
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 hover:border-orange-300 hover:bg-orange-50 hover:text-orange-600"
          title={loginLabel}
          aria-label={loginLabel}
        >
          <LogIn size={16} aria-hidden="true" />
        </Link> : actions}
      </div>
    </header>
  );
}
